<template lang="pug">
	//- Файлы, присланные пользователем, сгруппированные по типам (миниатюры картинок и видео есть только до перезагрузки страницы). Файлы, непригодные для ассетов, помечены с причиной
	.ai-chat-message-content.ai-chat-attachments
		span.ai-chat-attachments-prompt(v-if="message.options.prompt" v-html="formatMessageText(message.options.prompt)")
		.ai-chat-attachments-group(v-for="item in getGroups()" :key="item.group.codename")
			.ai-chat-attachments-group-title
				i.fa(:class="item.group.icon")
				span {{item.group.title}} ({{item.files.length}})
			.ai-chat-attachments-files
				//- Набор Spine (json + atlas + png), найденный сервером, - одна миниатюра (до перезагрузки страницы - проигрываемая анимация, потом - иконка)
				.ai-chat-attachment.spine(v-for="file in item.files" v-if="file.spineFiles" :key="'spine-' + file.spineKey" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: getSpineTooltip(file)}")
					.ai-chat-attachment-preview
						SpinePlayer(v-if="getSpinePreview(file)" :json="getSpinePreview(file).json" :atlas="getSpinePreview(file).atlas" :imageUrl="getSpinePreview(file).imageUrl" :width="62" :height="48" v-on:loaded="$emit('thumbnail-loaded', message)")
						i.fa(v-else :class="item.group.icon")
					.ai-chat-attachment-name {{file.name}}
				.ai-chat-attachment(v-for="file in item.files" v-if="!file.spineFiles" :key="file.index" :class="{unsupported: !file.assetType}" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: getTooltip(file)}")
					.ai-chat-attachment-preview
						img(v-if="item.group.codename === 'image' && getPreviewUrl(file)" :src="getPreviewUrl(file)" :alt="file.name" v-on:load="$emit('thumbnail-loaded', message)")
						video(v-else-if="item.group.codename === 'video' && getPreviewUrl(file)" :src="getPreviewUrl(file)" muted preload="metadata")
						i.fa(v-else :class="file.assetType ? item.group.icon : 'fa-ban'")
					.ai-chat-attachment-name {{file.name}}
					.ai-chat-attachment-error(v-if="!file.assetType") Not an asset
</template>

<script>
	import { AIAgent } 			from './../../services/AIAgent'

	import SpinePlayer 		from './../Dashboard/SpinePlayer'

	export default {
		name: "AIAgentMessageAttachments",
		components: {
			SpinePlayer
		},
		props: ['message'],
		methods: {
			formatMessageText(text) {

				return AIAgent.formatMessageText(text);

			},
			// Файлы сообщения, сгруппированные по типам (формат определён сервером по содержимому, если не определён - берём расширение имени).
			// Файлы наборов Spine (spineKey записал сервер) - одним элементом в группе Spine
			getGroups() {

				return AIAgent.groupAttachments(this.message.options.files || [], file => file.ext || AIAgent.getFileExtension(file.name), file => file.spineKey);

			},
			getSpineTooltip(spineSet) {

				return _.map(['json', 'atlas', 'png'], part => spineSet.spineFiles[part]?.path || spineSet.spineFiles[part]?.name).join(' + ') + ` · ${AIAgent.formatAttachmentSize(spineSet.size)} · Can be imported as asset type "spine"`;

			},
			getSpinePreview(spineSet) {

				return AIAgent.getAttachmentSpinePreview(this.message.options.uploadId, spineSet.spineKey);

			},
			getTooltip(file) {

				return _.compact([
					file.path || file.name,
					file.size ? AIAgent.formatAttachmentSize(file.size) : null,
					file.width ? `${file.width}x${file.height}` : null,
					file.assetType ? `Can be imported as asset type "${file.assetType}"` : `Can't be used as an asset: ${file.error}`
				]).join(' · ');

			},
			getPreviewUrl(file) {

				return file.assetType ? AIAgent.getAttachmentPreviewUrl(this.message.options.uploadId, file.index) : null;

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Сообщение пользователя с файлами
				.ai-chat-attachments
					.ai-chat-attachments-prompt
						display: block
						margin-bottom: 2px

					.ai-chat-attachment
						background-color: rgba(0,0,0,0.15)
						border-color: rgba(255,255,255,0.35)

</style>
